import { AutocompleteProvider } from "../../../types/enums";
import { IMapInstance, LatLng } from "../../maps/map-provider.interface";
import { GeoAddress, IGeoSearchProvider } from "../geo-search-provider.interface";

export class NoneGeoSearchProvider implements IGeoSearchProvider {
    getGeoSearchProvider(): AutocompleteProvider {
        return AutocompleteProvider.NONE;
    }

    async bindAutocompleteAsync(
        input: HTMLInputElement,
        mapInstance: IMapInstance,
        onSelected: (coords: LatLng) => void
    ): Promise<void> {
        // no-op
    }

    async bindAddressAutocompleteAsync(
        _input: HTMLInputElement,
        _options: { at?: LatLng; radiusMeters?: number },
        _onSelected: (selected: GeoAddress) => void
    ): Promise<void> {
        // no-op
    }

    async geocodeAsync(_query: string): Promise<LatLng | null> {
        return null;
    }

    async reverseGeocodeAsync(_coords: LatLng): Promise<GeoAddress | null> {
        return null;
    }

    dispose(): void {
        // no-op
    }
}